import { KngTableState, UploadFileSection } from 'kinetic-angular';
import { CommonErrorState } from '../../common-error';
import { IdLabelPair, Image } from '../../../services/shared/shared-interface';

export interface BusinessAccountRequest {
  state: BusinessAccountRequestState;
}
export interface BusinessAccountRequestState {
  sectionTop: BusinessAccountRequestSectionTop;
  sectionMiddle: BusinessAccountRequestSectionMiddle;
}

export interface BusinessAccountRequestSectionTop {
  pageHeading: string;
}

export interface BusinessAccountRequestSectionMiddle {
  tableHeading: string;
  grid: Grid;
  tableState: KngTableState;
  errorState:CommonErrorState;
  isError?:boolean;
  loading?: boolean;
  businessAccountData: BusinessAccountsGridData[];
}

export interface Grid {
  headers: IdLabelPair[];
  accept: AccountApproval;
  reject: AccountApproval;
  tooltip: string;
  uploadFile: string;
  companyGridLabel:string;
  noResult: AccountApproval;
  uploadFileLabels: UploadFileLabels;
}
export interface AccountApproval {
  label: string;
  iconPath: string;
  altText: string;
}
export interface BusinessAccountRequestLabel {
  pageHeading: string;
  tableHeading: string;
  grid: Grid;
}
export interface HeaderObj {
  id?: string;
  label: string;
  category?: string;
}
export enum AccountGrid {
  requestedBy = '001',
  requestedOn = '002',
  topLevelGrid = '003',
  adminCompanyDetails = '004',
  contact = '005',
  locationList='006',
  businessAccountApproval = '007',
}
export interface BusinessAccounttGridDefinition {
  gridData: BusinessAccountsGridData[];
}

export interface BusinessAccountsGridData {
  profileInformation: Contact;
  companyDetails: AdminCompanyDetails;
  pendingLocationDetails: LocationList;
  tempUserID: string;
  requestedOn: number;
  topLevelGrid:string;
  pendingUsers?: Contact[];
  dealerInfo?: DealerInfo;
}
export interface Contact {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}
export interface AdminCompanyDetails {
  primaryLocationGRID?: string;
  companyName: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  adminGrid?:string;
  tempUserID?: string;
}
export interface LocationList {
  erroredFileName: string;
  originalFileName: string;
  updatedFileName: string;
  locationListReviewed: boolean;
  primaryGridOnly: boolean;
}
export interface RejectBusinessAccountPayload {
  email: string;
}
export interface EditAdminCompanyDetailsAemLabels {
  heading: string;
  closeIcon: Image;
  errorText: {
    invalidCharacterWithoutNumericErrorMessage: string;
    invalidCharacterWithNumericErrorMessage: string;
    requiredErrorMessage: string;
    minLengthZipCodeError: string;
    canadaPostalCodeFormatError: string;
  };
  pageLabels: PageLabels;
  pageButtons: [{
      cancel: IdLabelPair;
      save: IdLabelPair;
    }];
}

export interface PageLabels {
  companyName: IdLabelPair;
  addressLine1: IdLabelPair;
  addressLine2: IdLabelPair;
  country: IdLabelPair;
  city: IdLabelPair;
  state: IdLabelPair;
  zipCode: IdLabelPair;
}

export interface ValidateAdminForm {
  accountName: boolean;
  addressLine1: boolean;
  country: boolean;
  city: boolean;
  state: boolean;
  postalCode: boolean;
}
export interface UploadFileLabels {
  heading: string;
  subHeading: string;
  closeIcon: Image;
  modelButtons: ModelButtons;
  uploadFile: UploadFileSection;
}
export interface ModelButtons {
  close: string;
  cancel: string;
  upload: string;
}
export interface UploadSuccessResponse {
  fileStatus: string;
  updatedFileName: string;
}
export interface ApproveBusinessAdminPayload {
  tempUserId: string;
}

export interface DealerInfo {
  dealerName: string;
  dealerEmail: string;
  dealerId: string;
}

export enum DealerLabels{
  dealer ='Dealer',
  user ='User',
  users ='others',
  id ='ID',
}
